import React from 'react'
import PropTypes from 'prop-types'
import { getLocaleInUnix } from 'ggx-src/legacy/utils/locale'
import { AdditionalServiceCharge } from 'ggx-src/van-booking/order/sidebar/order-form/summary/order-breakdown/price-breakdown/price-breakdown.component.js'
import { formatCurrency } from 'ggx-service/i18n/format-currency.service'
import { StyledLink } from 'ggx-src/van-booking/order/sidebar/order-form/summary/order-breakdown/price-breakdown/price-breakdown.component.styles'
import { useTranslation } from 'react-i18next'

const TunnelServiceItems = ({ serviceKeys, additionalService }) => {
  const [t] = useTranslation()
  const lang = getLocaleInUnix()
  const keys = serviceKeys.filter(key => key.startsWith('tunnel'))
  return (
    <>
      {keys.map(serviceKey => (
        <AdditionalServiceCharge
        key={serviceKey}
        title={
          additionalService[serviceKey].extras?.[lang] ||
          additionalService[serviceKey].title
        }
        value={
          <StyledLink as="a" noMargin id="tunnel-selection-link">
          {formatCurrency({
            amount: additionalService[serviceKey].value,
          })}
          </StyledLink>
        }
        />
      ))}
      {keys.length === 0 && (
        <AdditionalServiceCharge
        title={t('common__tunnel_preference')}
        value={
          <StyledLink as="a" noMargin id="tunnel-selection-link">
          {t('common_add')}
          </StyledLink>
        }
        />
      )}
    </>
  )
}

TunnelServiceItems.propTypes = {
  serviceKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  additionalService: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.number,
    }).isRequired,
  }).isRequired,
}

export { TunnelServiceItems }